/**
 * 积分管理
 */
export default {
  // orderList: "/order_info/select_course_order", // 课程订单
  pointDetails: "/pointsRecord/pageList", //积分明细
}
